import {FormControl} from '@angular/forms';

export type MapToFormControl<Type> = {
  [Property in keyof Type]: FormControl<Type[Property]>;
};
